import { Box } from "@mui/system";
import styled from "@emotion/styled";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { PropsWithChildren } from "react";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";

const StyledBoxTextIcon = styled(Box)({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  display: "inline-block",
  textDecoration: "underline",
});
interface PropsFileText extends PropsWithChildren {
  fileTextDownload?: string;
  fileTextColorRed?: boolean;
  onDownloadFile?: () => void;
  fileWidth?: boolean;
}
export const FileTextWithIcon = (props: PropsFileText) => {
  return (
    <Tooltip title={`${props.fileTextDownload}`}>
      <Box
        component={"span"}
        color={props.fileTextColorRed ? "error.main" : "primary.main"}
        onClick={props.onDownloadFile}
      >
        <StyledBoxTextIcon
          component={"span"}
          maxWidth={props.fileWidth ? 120 : 200}
        >
          {props.fileTextDownload}
        </StyledBoxTextIcon>
        {/* <Box component={'span'}> <FileDownloadIcon  fontSize="inherit"/> </Box> */}
      </Box>
    </Tooltip>
  );
};
